/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type NoiseReductionChannelFragment = {
	id: string;
	features: {
		name: { name: string } | null;
		noiseReduction: { enabled: boolean; level: Types.NoiseReductionLevel | null; percentage: number | null } | null;
		channelConfiguration: { enabled: boolean } | null;
	};
	description: {
		constraints: {
			noiseReduction: {
				level: { options: Array<Types.NoiseReductionLevel> | null };
				percentage: { range: { min: number; max: number; step: number } | null };
			} | null;
		};
		features: { channelConfiguration: { supported: boolean } };
	};
};

export type NoiseReductionChannelUpdateFragment = {
	id: string;
	features:
		| { channelConfiguration: { enabled: boolean } | null }
		| { name: { name: string } | null }
		| {
				noiseReduction: {
					enabled: boolean;
					level: Types.NoiseReductionLevel | null;
					percentage: number | null;
				} | null;
		  }
		| {};
};

export type NoiseReductionChannelQueryVariables = Types.Exact<{
	channelId: Types.Scalars['ID']['input'];
}>;

export type NoiseReductionChannelQueryOpResult = { node: NoiseReductionChannelFragment | {} };

export type NoiseReductionChannelSubscriptionVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;

export type NoiseReductionChannelSubscriptionOpResult = {
	nodeChanges: NoiseReductionChannelFragment | NoiseReductionChannelUpdateFragment | {};
};

export type NoiseReductionChannelMutationVariables = Types.Exact<{
	updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type NoiseReductionChannelMutationOpResult = {
	updateNodes: Array<{ error: { code: Types.ErrorCode; message: string } | null } | {}>;
};

export const NoiseReductionChannelFragment = gql`
	fragment NoiseReductionChannelFragment on AudioChannel {
		id
		features {
			name {
				name
			}
			noiseReduction {
				enabled
				level
				percentage
			}
			channelConfiguration {
				enabled
			}
		}
		description {
			constraints {
				noiseReduction {
					level {
						options
					}
					percentage {
						range {
							min
							max
							step
						}
					}
				}
			}
			features {
				channelConfiguration {
					supported
				}
			}
		}
	}
`;
export const NoiseReductionChannelUpdateFragment = gql`
	fragment NoiseReductionChannelUpdateFragment on AudioChannelChange {
		id
		features {
			... on AudioChannelNameChange {
				name {
					name
				}
			}
			... on AudioChannelNoiseReductionChange {
				noiseReduction {
					enabled
					level
					percentage
				}
			}
			... on AudioChannelChannelConfigurationChange {
				channelConfiguration {
					enabled
				}
			}
		}
	}
`;
export const NoiseReductionChannelQueryDocument = gql`
	query NoiseReductionChannelQuery($channelId: ID!) {
		node(id: $channelId) {
			...NoiseReductionChannelFragment
		}
	}
	${NoiseReductionChannelFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class NoiseReductionChannelQueryGQL extends Apollo.Query<
	NoiseReductionChannelQueryOpResult,
	NoiseReductionChannelQueryVariables
> {
	override document = NoiseReductionChannelQueryDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const NoiseReductionChannelSubscriptionDocument = gql`
	subscription NoiseReductionChannelSubscription($id: ID!, $types: [NodeChangeType!]!) {
		nodeChanges(id: $id, types: $types) {
			... on AudioChannel {
				...NoiseReductionChannelFragment
			}
			... on AudioChannelChange {
				...NoiseReductionChannelUpdateFragment
			}
		}
	}
	${NoiseReductionChannelFragment}
	${NoiseReductionChannelUpdateFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class NoiseReductionChannelSubscriptionGQL extends Apollo.Subscription<
	NoiseReductionChannelSubscriptionOpResult,
	NoiseReductionChannelSubscriptionVariables
> {
	override document = NoiseReductionChannelSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const NoiseReductionChannelMutationDocument = gql`
	mutation NoiseReductionChannelMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
		updateNodes(updates: $updates, keyring: $injectKeyring) {
			... on AudioChannelOperationResult {
				error {
					code
					message
				}
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class NoiseReductionChannelMutationGQL extends Apollo.Mutation<
	NoiseReductionChannelMutationOpResult,
	NoiseReductionChannelMutationVariables
> {
	override document = NoiseReductionChannelMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
